// we can add back email, phoneString, and phoneRegex later if needed from the old project's validate.js
export const phoneFormatter = /^((\+1)|1)? ?\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})( ?(ext\.? ?|x)(\d*))?$/;

// used as a fallback for long numbers without a extension delimeter - this will treat any extra digits (after 10) as an extension: 
export const fallbackPhoneFormatter = /^((\+1)|1)? ?\(?(\d{3})\)?[ .-]?(\d{3})[ .-]?(\d{4})(\d{1,5})?$/;